import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from 'react';
import { logout, getUser, getData } from 'utils/service';
import { toast } from "react-toastify";
import { confirm } from "react-confirm-box";
import {
  useAppDispatch,
  useAppSelector,
} from 'app/hooks';
import {
  getDashboardData,
  selectDashboard,
} from 'features/dashboard/dashboardSlice';

const Header = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const {
    data, 
    pending, 
    error,
  } = useAppSelector(selectDashboard);
  // console.log('dashboardData...',data)
  const [user, setUser] = useState(getUser());
  const [currentPage, setCurrentPage] = useState('')

  useEffect(() => {
    dispatch(getDashboardData())
    // getDashboard()
  }, [])

  useEffect(() => {
    setCurrentPage(location.pathname)
  }, [location]);

  useEffect(() => {
    
    // setCurrentPage(Router.pathname)
    if(user){
      checkDevice(user.device_id);
    }
    
}, [])
const checkDevice = async (device_id: any) => {
  let response:any = await getData('device?device_id='+device_id);
  if(response?.data?.can_login == "0"){
    const options:any = {
      render: (message:any, onConfirm:any, onCancel:any) => {
        return (
          <div className='bg-black p-3'>
            <div className='text-white'> {message} </div>
            <div className="d-flex justify-content-center mt-4">
            <button className="btn btn-warning" onClick={onConfirm}> Okay </button>
            </div>
            
          </div>
        );
      }
    };
    const result = await confirm("You have logged in another device?",options);
    if (result) {
      logoutUser()
      return;
    }
    
  } 
}
const logoutUser = () => {
  logout()
  toast.success('You have logged out successfully.')
  window.location.href = 'login'
}
const comingSoon = () => {
  toast.warning("Coming Soon!")
}
const toggleSidebar = () => {
  var element = document.getElementById("sidebar");
  if (element) element.classList.toggle("active");

  var questionElement = document.getElementById("question-menu");
  var sidebarEement = document.getElementById("sidebar-menu");
  if(sidebarEement && questionElement){
      if(sidebarEement.classList.contains('fa-bars')){
          sidebarEement.classList.remove("fa-bars");
          sidebarEement.classList.add("fa-xmark");

          questionElement.classList.remove("fa-filter");
          questionElement.classList.add("fa-xmark");

          var element2 = document.getElementById("question-filter");
          if (element2) element2.classList.remove("hide");

      }else{
          sidebarEement.classList.add("fa-bars");
          sidebarEement.classList.remove("fa-xmark");
      }
     
  }
  document.body.classList.toggle("sidebar-enable");
}

  return (
    <header id="main-header">

      <nav className="navbar navbar-expand-lg navbar-dark bg-blue px-5">
        <div className="container-fluid">
          <div className="navbar-brand">
            {/* <i className="fa fa-home me-2"></i> */}
            <img src='logo.png' height={50}/>
          </div>

          <button onClick={toggleSidebar} className="navbar-toggler" type="button" data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
            aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
            <ul className={`navbar-nav mb-2 mb-lg-0 ${user ? 'me-auto px-2' : ''}`}>
            {!user && <>
              <li className="nav-item">
                <a href="https://vergeca.in" className={`nav-link py-3 text-white`} aria-current="page">Home</a>
              </li>
              <li className="nav-item">
                <a href="https://vergeca.in/about" className={`nav-link py-3 text-white`} aria-current="page">About Us</a>
              </li>
              <li className="nav-item">
                <a href="https://vergeca.in/features" className={`nav-link py-3 text-white`} aria-current="page">Features</a>
              </li>
              <li className="nav-item">
                <a href="https://vergeca.in/coverage" className={`nav-link py-3 text-white`} aria-current="page">Coverage</a>
              </li>
              <li className="nav-item">
                <a href="https://vergeca.in/demo" className={`nav-link py-3 text-white`} aria-current="page">Demo</a>
              </li>
              <li className="nav-item">
                <a href="https://vergeca.in/subscription" className={`nav-link py-3 text-white`} aria-current="page">Subscription</a>
              </li>
              <li className="nav-item">
                <a href="https://vergeca.in/testimonials" className={`nav-link py-3 text-white`} aria-current="page">Testimonials</a>
              </li>
              <li className="nav-item">
                <a href="https://vergeca.in/daughters-of-india" className={`nav-link py-3 text-white`} aria-current="page">Daughters of India</a>
              </li>
              <li className="nav-item">
                <a href="https://vergeca.in/contact-us" className={`nav-link py-3 text-white`} aria-current="page">Contact</a>
              </li>
              
            </>}
              {user && <>
              <li className="nav-item">
                <Link to="/dashboard" className={`nav-link py-3 text-white ${(currentPage === '/dashboard') ? 'text-white' : ''}`} aria-current="page">Dashboard</Link>
              </li>
              <li className="nav-item">
                <Link to="/questions" className={`nav-link py-3 text-white ${(currentPage === '/questions') ? 'text-white' : ''}`} aria-current="page">Questions</Link>
              </li>
              <li className="nav-item">
                <Link to="/performance" className={`nav-link py-3 text-white ${(currentPage === '/performance') ? 'text-white' : ''}`} aria-current="page">Your Performance</Link>
              </li>
              {/* <li className="nav-item">
                <Link to="/downloads" className={`nav-link py-3 text-white ${(currentPage === '/downloads') ? 'text-white' : ''}`} aria-current="page">Downloads</Link>
              </li> */}
               <li className="nav-item">
                <Link to="/coverage" className={`nav-link py-3 text-white ${(currentPage === '/coverage') ? 'text-white' : ''}`} aria-current="page">Coverage</Link>
              </li>
              <li className="nav-item">
                <Link to="/demos" className={`nav-link py-3 text-white ${(currentPage === '/demos') ? 'text-white' : ''}`} aria-current="page">Videos</Link>
              </li>
              <li className="nav-item">
                <Link to="/account" className={`nav-link py-3 text-white ${(currentPage === '/account') ? 'text-white' : ''}`} aria-current="page">Profile / Subscription</Link>
              </li>
              {/* <li className="nav-item">
                <span className="nav-link py-3 text-white cursor-pointer" aria-current="page" onClick={comingSoon}>Share with friends</span>
              </li> */}
              
              <li className="nav-item">
                <Link to="/notifications" className={`nav-link py-3 text-white ${(currentPage === '/notifications') ? 'text-white' : ''}`} aria-current="page">Notifications</Link>
              </li>
             
              <li className="nav-item">
                <Link to="/contact-us" className={`nav-link py-3 text-white ${(currentPage === '/contact-us') ? 'text-white' : ''}`} aria-current="page">Contact us</Link>
              </li>

              </>}
              
            </ul>
            {user && <div className="d-flex"><label className='text-white fw-bold'>Welcome: <span className='text-orange'>{user.first_name} {user.last_name}</span> </label></div>}
            {/* {user &&
              <form className="d-flex">
                <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
                <button className="btn btn-outline-success" type="button">Search</button>
              </form>
            } */}
          </div>
        </div>
      </nav>
    </header>
  )
}

export default Header;
